import React from 'react'
import { bool, string } from 'prop-types'

const Toast = ({ text, isVisible }) => (
  <div className="toast">
    {text}

    <style jsx>
      {`
        .toast {
          z-index: 99;
          position: fixed;
          bottom: 80px;
          margin: 1% auto;
          left: 50%;
          transform: translateX(-50%) scale(${isVisible ? 1 : 0});

          display: flex;
          align-items: center;
          justify-content: center;

          background: rgba(0,0,0,.6);
          color: #fff;
          font-size: 16px;
          text-align: center;
          padding: 16px 8px;
          border-radius: 8px;

          opacity: 1;
          transition: transform 0.2s ease;
        }
      `}
    </style>
  </div>
)

Toast.propTypes = {
  text: string,
  isVisible: bool,
}

export default Toast
